import { render } from "./ViewAttach.vue?vue&type=template&id=0da4351f&scoped=true"
import script from "./ViewAttach.vue?vue&type=script&lang=js"
export * from "./ViewAttach.vue?vue&type=script&lang=js"

import "./ViewAttach.vue?vue&type=style&index=0&id=0da4351f&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da4351f"]])

export default __exports__